export enum UserRequestFilterStatus {
    Priority = -1,
    AZ = -2,
    DueDate = -4,
    Active = -7,
    Archived = -3,
    Draft = 0,
    SubmittedPending = 1,
    WaitingOnFollowUp = -5,
    FollowUpNotExpiring = 5,
    FollowUpExpiring = 10,
    FollowUpExpired = 11,
    FollowUpSubmitted = 6,
    FollowUpForgiven = -6,
    Disapproved = 3,
    Completed = 8,
    Cancelled = 9,
}
